export default {
  /* Supported Extensions */
  //Sort srcExt alphabetically:
  srcExt: ["890", "asc", "ass", "bin", "cap", "cca", "ccprj", "cin", "cip", "csv", "dfxp", "docx", "edl", "esf", "flc", "fpc", "imscr", "itt", "json", "mcc", "mp4", "pac", "rtf", "sami", "sbv", "scc", "sdb", "smi", "srt", "ssa", "stl", "sub", "ts", "ttml", "txt", "vnl", "vtt", "webvtt", "xlsx", "xml"],
  trgExt: ["890", "asc", "ass", "cap", "ccprj", "csv", "dfxp", "docx", "edl", "esf", "flc", "fpc", "imscr", "itt", "json", "mcc", "raw", "pac", "sami", "sbv", "scc", "smi", "srt", "ssa", "stl", "sub", "ttml", "txt", "vnl", "vtt", "webvtt", "xlsx", "xml", "zip"],
  srcProfiles: {
    "xlsx": ["DVW QC Script", "DVW Studio Script", "ExAD"],
    "890": ["Cavena 890"],
    "itt": ["iTunes Timed Text", "iTunes Timed Text Media", "iTunes Timed Text SMPTE"],
    "cca": ["MacCaption Project"],
    "ccprj": ["Closed Caption Project"],
    "cin": ["Caption Inc"],
    "cip": ["Cavena CIP"],
    "docx": ["LMS Transcript", "MS2 Transcript"],
    "edl": ["Davinci Resolve Timeline Markers"],
    "esf": ["ESEF"],
    "flc": ["NCI Timed Roll Up Captions"],
    "ssa": ["Substation Alpha"],
    "ass": ["Advanced Substation Alpha"],
    "scc": ["Scenarist V1.0"],
    "mcc": ["MacCaption 608/708"],
    "rtf": ["Rich Text Format Custom 01"],
    "srt": ["SubRip Video Subtitle Script"],
    "vtt": ["WebVTT", "Able Player DV"],
    "webvtt": ["WebVTT", "Able Player DV"],
    "sbv": ["SubViewer"],
    "sdb": ["Canvass SST Project"],
    "sub": ["SubViewer", "Sofni", "Micro DVD", "DVD Architect"],
    "txt": ["Avid DS", "Adobe Encore", "Apple DVD Studio Pro", "EZ Title", "PowerPixel Format", "ProCap Transfer", "QuickTime Text", "Eclipse", "Text Transcript"],
    "stl": ["EBU STL", "Spruce STL"],
    "pac": ["ScreenSystems Poliscript"],
    "fpc": ["PAC Unicode (UniPac)"],
    "cap": ["Cheetah (binary)", "Videotron Lambda", "NCI Caption", "CaptionMaker Plus", "CaptionMaker Plus V2"],
    "asc": ["Cheetah (ASCII Text)"],
    "xml": ["Timed-Text Markup Language", "Distribution Format Exchange Profile (DFXP)", "DLP Cinema", "Netflix TT Captions", "Netflix TT Subtitles", "MAGIC TT", "EBU TT", "EBU-TT-D", "SMPTE TTML", "IMSC Text Captions", "IMSC Text Subtitles", "IMSC 1.1 Text Profile", "IMSC Rosetta", "DCDM Subtitle", "Ooona TTML", "IMSC 1.0 Basic", "TTML FooEngine", "Sandflow TTML", "YouTube TTML", "Adobe TTML", "A&E TTML", "Broadstream TTML"],
    "ttml": ["Timed-Text Markup Language", "Verizon TTML", "EBU-TT-D", "SMPTE TTML", "IMSC Text Captions", "IMSC Text Subtitles", "IMSC 1.1 Text Profile", "IMSC Rosetta", "Ooona TTML", "IMSC 1.0 Basic", "TTML FooEngine", "Sandflow TTML", "YouTube TTML", "A&E TTML", "Broadstream TTML"],
    "imscr": ["IMSC Rosetta"],
    "mp4": ["Timed-Text Markup Language", "Verizon TTML", "SMPTE TTML", "IMSC Text Captions", "IMSC Text Subtitles", "IMSC 1.1 Text Profile"],
    "dfxp": ["Distribution Format Exchange Profile (DFXP)", "Timed-Text Markup Language", "Netflix DFXP", "Crunchyroll DFXP"],
    "smi": ["Synchronized Accessible Media Interchange"],
    "csv": ["Comma-Separated Values", "Davinci Resolve ADR Cue List", "Davinci Resolve Edit Index List"],
    "json": ["Google Speech-to-Text", "Assembly AI", "Gladia", "Deepgram", "Rev AI", "Voicegain", "Speechmatics", "Amazon Transcribe", "ElevenLabs Scribe", "Whisper", "JSON Format Custom 01"],
    "sami": ["Synchronized Accessible Media Interchange"],
    "vnl": ["Vitac"],
    "ts": ["DVB Teletext TS Stream"]
  },
  trgProfiles: {
    "890": ["Cavena 890"],
    "ccprj": ["Closed Caption Project"],
    "docx": ["LMS Transcript", "MS2 Transcript", "As-Broadcast Dialogue List Word", "Dialogue List Custom 01"],
    "cap": ["Cheetah (binary)", "Videotron Lambda"],
    "xlsx": ["DVW QC Script", "DVW Studio Script", "ExAD"],
    "edl": ["Davinci Resolve Timeline Markers"],
    "esf": ["ESEF"],
    "flc": ["NCI Timed Roll Up Captions"],
    "itt": ["iTunes Timed Text", "iTunes Timed Text Media", "iTunes Timed Text SMPTE"],
    "scc": ["Scenarist V1.0", "Scenarist V1.0 Advanced"],
    "ssa": ["Substation Alpha"],
    "ass": ["Advanced Substation Alpha"],
    "mcc": ["MacCaption 608/708", "MacCaption 608/708 Advanced"],
    "raw": ["608/708 VANC Data"],
    "srt": ["SubRip Video Subtitle Script"],
    "vtt": ["WebVTT", "Able Player DV"],
    "pac": ["ScreenSystems Poliscript"],
    "fpc": ["PAC Unicode (UniPac)"],
    "webvtt": ["WebVTT", "Able Player DV"],
    "sbv": ["SubViewer"],
    "sub": ["SubViewer", "Sofni", "Micro DVD", "DVD Architect"],
    "txt": ["Avid DS", "Adobe Encore", "Apple DVD Studio Pro", "EZ Title", "ProCap Transfer", "PowerPixel Format", "QuickTime Text", "Eclipse", "Text Transcript"],
    "stl": ["EBU STL", "Spruce STL"],
    "asc": ["Cheetah (ASCII Text)"],
    "xml": ["Timed-Text Markup Language", "Distribution Format Exchange Profile (DFXP)", "DLP Cinema", "Netflix TT Captions", "Netflix TT Subtitles", "MAGIC TT", "EBU TT", "EBU-TT-D", "HBO GO TTML", "HBO MAX SMPTE", "HBO SMPTE TTML", "TTML Legacy", "SMPTE TTML", "YouTube TTML", "FCP XML", "IMSC Text Captions", "IMSC Text Subtitles", "IMSC Text Captions - JA", "IMSC 1.1 Text Profile", "IMSC Rosetta", "Ooona TTML", "IMSC 1.0 Basic", "TTML FooEngine", "Sandflow TTML", "Disney TTML", "Paramount IMSC 1.1", "Adobe TTML", "A&E TTML", "Broadstream TTML"],
    "ttml": ["Timed-Text Markup Language", "Verizon TTML", "EBU-TT-D", "HBO GO TTML", "HBO MAX SMPTE", "HBO SMPTE TTML", "TTML Legacy", "SMPTE TTML", "YouTube TTML", "IMSC Text Captions", "IMSC Text Subtitles", "IMSC Text Captions - JA", "IMSC 1.1 Text Profile", "IMSC Rosetta", "Ooona TTML", "IMSC 1.0 Basic", "TTML FooEngine", "Sandflow TTML", "Disney TTML", "Paramount IMSC 1.1", "Broadstream TTML"],
    "imscr": ["IMSC Rosetta"],
    "dfxp": ["Distribution Format Exchange Profile (DFXP)", "Netflix DFXP", "Crunchyroll DFXP"],
    "smi": ["Synchronized Accessible Media Interchange"],
    "sami": ["Synchronized Accessible Media Interchange"],
    "csv": ["Comma-Separated Values", "As-Broadcast Dialogue List CSV", "Davinci Resolve ADR Cue List", "Davinci Resolve Edit Index List"],
    "json": ["JSON"],
    "vnl": ["Vitac"]
  },
  profileMapping: {
    "Paramount IMSC 1.1": {
      name: "paramountImsc11",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en-US"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "proportionalSansSerif"
        }]
      }
    },
    "Disney TTML": {
      name: "disneyTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }]
      }
    },
    "Sandflow TTML": {
      name: "sandflowTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospace"
        }, {
          name: "Font Size (%)",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Style",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }]
      }
    },
    "TTML FooEngine": {
      name: "ttmlFooEngine",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Timebase",
          type: "list",
          values: ["media", "clock"],
          selected: "media"
        }, {
          name: "Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Description",
          type: "text-input",
          values: "",
          selected: "TTML IMSC 1"
        }, {
          name: "Copyright",
          type: "text-input",
          values: "",
          selected: ""
        }]
      }
    },
    "DVW Studio Script": {
      name: "dvwStudioScript",
      options: {
        decode: [],
        encode: [{
          "name": "Include SMPTE Timestamps",
          "type": "list",
          "values": ["yes", "no"],
          "selected": "yes"
        }, {
          "name": "Include Frame Count",
          "type": "list",
          "values": ["yes", "no"],
          "selected": "yes"
        }, {
          "name": "Frame Count Rate",
          "type": "list",
          "values": ["match", 23.976, 24, 25, 29.97, 30, 50, 59.94, 60],
          "selected": "match"
        }, {
          "name": "Frame Offset",
          "type": "number-input",
          "values": "",
          "selected": 0
        }]
      }
    },
    "DVW QC Script": {
      name: "dvwQcScript",
      options: {
        decode: [],
        encode: []
      }
    },
    "ExAD": {
      name: "exad",
      options: {
        decode: [],
        encode: []
      }
    },
    "Davinci Resolve Timeline Markers": {
      name: "davinciResolveTimelineMarkers",
      options: {
        decode: [],
        encode: []
      }
    },
    "Caption Inc": {
      name: "captionInc",
      options: {
        decode: [],
        encode: []
      }
    },
    "MacCaption Project": {
      name: "cca",
      options: {
        decode: [],
        encode: []
      }
    },
    "MS2 Transcript": {
      name: "ms2Transcript",
      options: {
        decode: [],
        encode: []
      }
    },
    "LMS Transcript": {
      name: "lmsTranscript",
      options: {
        decode: [],
        encode: []
      }
    },
    "Dialogue List Custom 01": {
      "name": "dialogueListCustom01",
      "options": {
        "decode": [],
        "encode": [{
          name: "Export Speakers",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Recipients",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Notes",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Reply",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["SMPTE", "Clock"],
          selected: "SMPTE"
        }, {
          name: "Export Start Time",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export End Time",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Duration",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }]
      }
    },
    "As-Broadcast Dialogue List Word": {
      name: "dialogueListWord",
      options: {
        decode: [],
        encode: [{
          name: "Export Title Page",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Title",
          type: "text-input",
          values: "",
          selected: "DEFAULT TITLE"
        }, {
          name: "Export Metadata",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Event Id",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Speakers",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Tags",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Notes",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Reply",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["SMPTE", "Clock"],
          selected: "SMPTE"
        }, {
          name: "Export Start Time",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export End Time",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Duration",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }]
      }
    },
    "Davinci Resolve ADR Cue List": {
      name: "davinciResolveAdrCueList",
      options: {
        decode: [],
        encode: []
      }
    },
    "ESEF": {
      name: "esef",
      options: {
        decode: [],
        encode: [{
          name: "Title",
          type: "text-input",
          values: [],
          selected: ""
        }, {
          name: "Fade Duration Frames",
          type: "list",
          values: ["0", "3", "10", "25"],
          selected: "3"
        }, {
          name: "Full Last Trailer",
          type: "list",
          values: ["no", "yes"],
          selected: "no"
        }]
      }
    },
    "Davinci Resolve Edit Index List": {
      name: "davinciResolveEditIndexList",
      options: {
        decode: [],
        encode: []
      }
    },
    "As-Broadcast Dialogue List CSV": {
      name: "dialogueListCsv",
      options: {
        decode: [],
        encode: [{
          name: "Export Event Id",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Speakers",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Tags",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Notes",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Reply",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["SMPTE", "Clock"],
          selected: "SMPTE"
        }, {
          name: "Export Start Time",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export End Time",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Export Duration",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }]
      }
    },
    "Closed Caption Project": {
      name: "closedCaptionProject",
      options: {
        decode: [],
        encode: []
      }
    },
    "iTunes Timed Text": {
      name: "iTunesTimedText",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en-US"
        }, {
          name: "Timecode Source",
          type: "list",
          values: ["media", "clock", "smpte"],
          selected: "smpte"
        }]
      }
    },
    "iTunes Timed Text Media": {
      name: "iTunesTimedText",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en-US"
        }, {
          name: "Timecode Source",
          type: "list",
          values: ["media", "clock", "smpte"],
          selected: "media"
        }]
      }
    },
    "iTunes Timed Text SMPTE": {
      name: "iTunesTimedText",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en-US"
        }, {
          name: "Timecode Source",
          type: "list",
          values: ["media", "clock", "smpte"],
          selected: "smpte"
        }]
      }
    },
    "ElevenLabs Scribe": {
      name: "elevenLabsScribe",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }, {
          name: "Import Target",
          type: "list",
          values: ["Transcript", "Audio Events"],
          selected: "Transcript"
        }],
        encode: []
      }
    },
    "GPT Transcribe": {
      name: "aiTranscript",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Gemini 2.5 Pro": {
      name: "aiTranscript",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Gemini 3.5 Transcribe": {
      name: "aiTranscript",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Whisper": {
      name: "whisper",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }, {
          name: "Import Target",
          type: "list",
          values: ["Transcript", "Audio Events"],
          selected: "Transcript"
        }],
        encode: []
      }
    },
    "Google Speech-to-Text": {
      name: "googleStt",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Assembly AI": {
      name: "assemblyAi",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Gladia": {
      name: "gladia",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Voicegain": {
      name: "voicegain",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Speechmatics": {
      name: "speechmatics",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 2
        }, {
          name: "Import Target",
          type: "list",
          values: ["Translation", "Transcript", "Audio Events"],
          selected: "Transcript"
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: ""
        }],
        encode: []
      }
    },
    "Deepgram": {
      name: "deepgram",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Amazon Transcribe": {
      name: "amazonTranscribe",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Rev AI": {
      name: "revAi",
      options: {
        decode: [{
          name: "Import Type",
          type: "list",
          values: ["subtitle", "transcription", "word map"],
          selected: "subtitle"
        }, {
          name: "Max Characters",
          type: "number-input",
          values: "",
          selected: 32
        }, {
          name: "Max Lines",
          type: "number-input",
          values: "",
          selected: 3
        }],
        encode: []
      }
    },
    "Vitac": {
      name: "vitac",
      options: {
        decode: [],
        encode: [{
          name: "Title",
          type: "text-input",
          values: "",
          selected: "Untitled"
        }]
      }
    },
    "FCP XML": {
      name: "fcpXml",
      /* Encode/Decode Options */
      options: {
        decode: [],
        encode: [{
          name: "Project Name",
          type: "text-input",
          values: "",
          selected: "SUBTITLES"
        }, {
          name: "File Extension",
          type: "text-input",
          values: "",
          selected: "wav"
        }, {
          name: "Height",
          type: "list",
          values: ["1080", "1440", "2160", "2880", "4320"],
          selected: "1080"
        }, {
          name: "Width",
          type: "list",
          values: ["1920", "2560", "3840", "5120", "7680"],
          selected: "1920"
        }, {
          name: "Font Style",
          type: "list",
          values: ["Arial", "Lucida Sans", "Helvetica", "Times New Roman", "Courier", "Verdana", "Georgia", "Palatino", "Garamond", "Bookman", "Impact"],
          selected: "Lucida Sans"
        }, {
          name: "Font Size",
          type: "text-input",
          values: "",
          Selected: "36"
        }]
      }
    },
    "QuickTime Text": {
      name: "quickTimeText",
      options: {
        decode: [],
        encode: []
      }
    },
    "Micro DVD": {
      name: "uDvd",
      options: {
        decode: [],
        encode: []
      }
    },
    "HBO GO TTML": {
      name: "hboGoTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "proportionalSansSerif"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "16"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "transparent"
        }, {
          name: "Line Height",
          type: "text-input",
          values: "",
          selected: "125"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "ms"
        }]
      }
    },
    "HBO MAX SMPTE": {
      name: "hboMaxSmpte",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospace"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }]
      }
    },
    "HBO SMPTE TTML": {
      name: "hboSmpteTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "es"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospace"
        }, {
          name: "Line Height",
          type: "text-input",
          values: "",
          selected: "8"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "8"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "bold"
        }, {
          name: "Outline Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Outline Vertical Size",
          type: "number-input",
          values: "",
          selected: "5"
        }, {
          name: "Outline Horizontal Size",
          type: "number-input",
          values: "",
          selected: "3"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "ms"
        }]
      }
    },
    "TTML Legacy": {
      name: "ttmlLegacy",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "proportionalSansSerif"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "transparent"
        }, {
          name: "Line Height",
          type: "text-input",
          values: "",
          selected: "125"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "ms"
        }]
      }
    },
    "IMSC Text Captions - JA": {
      name: "imscTextCaptionsJa",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Version",
          type: "list",
          values: ["1.0", "1.1"],
          selected: "1.1"
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "ja"
        }, {
          name: "Aspect Ratio",
          type: "list",
          values: ["4:3", "16:9", "9:16"],
          selected: "4:3"
        }, {
          name: "Program Name",
          type: "text-input",
          values: "",
          selected: "Untitled"
        }, {
          name: "Program Description",
          type: "text-input",
          values: "",
          selected: "Create by CC Converter 3"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "proportionalSansSerif"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Line Height",
          type: "number-input",
          values: "",
          selected: "100"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Style",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "ms"
        }]
      }
    },
    "IMSC Text Captions": {
      name: "imscTextCaptions",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Version",
          type: "list",
          values: ["1.0", "1.1"],
          selected: "1.0"
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Aspect Ratio",
          type: "list",
          values: ["4:3", "16:9", "9:16"],
          selected: "4:3"
        }, {
          name: "Program Name",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospaceSerif"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Line Height",
          type: "number-input",
          values: "",
          selected: "100"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Style",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }]
      }
    },
    "IMSC Text Subtitles": {
      name: "imscTextSubtitles",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Extent X",
          type: "number-input",
          values: "",
          selected: "720"
        }, {
          name: "Extent Y",
          type: "number-input",
          values: "",
          selected: "480"
        }, {
          name: "Aspect Ratio",
          type: "list",
          values: ["4:3", "16:9", "9:16"],
          selected: "4:3"
        }, {
          name: "Program Name",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospaceSerif"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Line Height",
          type: "number-input",
          values: "",
          selected: "100"
        }, {
          name: "Font Style",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }]
      }
    },
    "IMSC 1.1 Text Profile": {
      name: "imsc11",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Aspect Ratio",
          type: "list",
          values: ["4:3", "16:9", "9:16"],
          selected: "16:9"
        }, {
          name: "Program Name",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospaceSerif"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Line Height",
          type: "number-input",
          values: "",
          selected: "100"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Style",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Absolute Position",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Text Outline Color",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Text Outline Size",
          type: "number-input",
          values: "",
          selected: "2"
        }, {
          name: "Text Outline Size Unit",
          type: "list",
          values: ["px", "%", "em"],
          selected: "px"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }, {
          name: "Time Base",
          type: "list",
          values: ["media", "smpte", "clock"],
          selected: "media"
        }]
      }
    },
    "IMSC Rosetta": {
      name: "imscRosetta",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Program Name",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "5.333"
        }, {
          name: "Default Outline",
          type: "list",
          values: ["outline", "drop", "none"],
          selected: "outline"
        }]
      }
    },
    "IMSC 1.0 Basic": {
      name: "imscBasic",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Description",
          type: "text-input",
          values: "",
          selected: "TTML IMSC 1"
        }, {
          name: "Copyright",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en-US"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "Arial"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "ms"
        }, {
          name: "Time Base",
          type: "list",
          values: ["media", "smpte", "clock"],
          selected: "media"
        }]
      }
    },
    "Ooona TTML": {
      "name": "ooonaTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Title",
          type: "text-input",
          values: "",
          selected: "Unknown"
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en-US"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "Arial"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "100"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "#ffffff"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "ms"
        }, {
          name: "Time Base",
          type: "list",
          values: ["media", "smpte", "clock"],
          selected: "media"
        }]
      }
    },
    "SMPTE TTML": {
      name: "smpteTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospace"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }, {
          name: "Time Base",
          type: "list",
          values: ["media", "smpte", "clock"],
          selected: "smpte"
        }]
      }
    },
    "A&E TTML": {
      name: "aeTtml",
      options: {
        decode: [{
          name: "Mode",
          type: "list",
          values: ["Subtitle", "Closed Caption"],
          selected: "Subtitle"
        }],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Mode",
          type: "list",
          values: ["Subtitle", "Closed Caption"],
          selected: "Subtitle"
        }]
      }
    },
    "Adobe TTML": {
      name: "adobeTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospace"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }, {
          name: "Time Base",
          type: "list",
          values: ["media", "smpte", "clock"],
          selected: "smpte"
        }]
      }
    },
    "Broadstream TTML": {
      name: "broadstreamTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "Arial"
        }, {
          name: "Font Size",
          type: "text-input",
          values: "",
          selected: "18px"
        }, {
          name: "Font Style",
          type: "list",
          values: ["normal", "italic", "oblique"],
          selected: "normal"
        }, {
          name: "Color",
          type: "text-input",
          values: "",
          selected: "#FFFFFF"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "rgba(0,0,0,0)"
        }, {
          name: "Text Outline",
          type: "text-input",
          values: "",
          selected: "#000000 1px 1px"
        }]
      }
    },
    "YouTube TTML": {
      name: "youtubeTtml",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospace"
        }, {
          name: "Font Size (%)",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Style",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }, {
          name: "Time Base",
          type: "list",
          values: ["media", "smpte", "clock"],
          selected: "smpte"
        }]
      }
    },
    "Substation Alpha": {
      name: "subStationAlpha",
      options: {
        decode: [],
        encode: []
      }
    },
    "Advanced Substation Alpha": {
      name: "subStationAlpha",
      options: {
        encode: [{
          "name": "Border Style",
          "type": "list",
          "values": ["1", "3"],
          "selected": "1"
        }, {
          name: "Font Family",
          type: "list",
          values: ["serif", "sans-serif", "monospace", "cursive", "fantasy", "Arial", "Verdana", "Helvetica", "Tahoma", "Trebuchet MS", "Trebuchet", "Arial Bold", "Adobe Arabic", "Arial Unicode MS", "Noto Sans Thai", "Noto Sans Chinese", "Microsoft Yahei", "Times New Roman", "Georgia", "Garamond", "Courier New", "Brush Script MT"],
          selected: "monospace"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: 23
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "#ffffff"
        }, {
          name: "Opacity",
          type: "number-input",
          values: "",
          selected: 100
        }, {
          name: "Letter Spacing",
          type: "number-input",
          values: "",
          selected: 10
        }, {
          name: "Shadow Size (px)",
          type: "number-input",
          values: "",
          selected: "0"
        }, {
          name: "Shadow Color",
          type: "text-input",
          values: "",
          selected: "#000000"
        }, {
          name: "Shadow Opacity",
          type: "number-input",
          values: "",
          selected: "100"
        }, {
          name: "Outline Size (px)",
          type: "number-input",
          values: "",
          selected: "0"
        }, {
          name: "Outline Color",
          type: "text-input",
          values: "",
          selected: "#000000"
        }, {
          name: "Outline Opacity",
          type: "number-input",
          values: "",
          selected: "100"
        }, {
          name: "Video Width",
          type: "number-input",
          values: "",
          selected: 1280
        }, {
          name: "Video Height",
          type: "number-input",
          values: "",
          selected: 720
        }, {
          name: "ScaleX",
          type: "number-input",
          values: "",
          selected: 100
        }, {
          name: "ScaleY",
          type: "number-input",
          values: "",
          selected: 100
        }, {
          name: "Margin X",
          type: "number-input",
          values: "",
          selected: 128
        }, {
          name: "Margin Y",
          type: "number-input",
          values: "",
          selected: 72
        }, {
          name: "Bold All",
          "type": "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Italics All",
          "type": "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Underline All",
          "type": "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Strikeout All",
          "type": "list",
          values: ["yes", "no"],
          selected: "no"
        }],
        decode: [{
          "name": "Excluded Style Types",
          "type": "text-input",
          "values": "",
          "selected": ""
        }, {
          "name": "Use Regex for Excluded Style Types",
          "type": "list",
          "values": ["yes", "no"],
          "selected": "no"
        }, {
          "name": "Included Style Types",
          "type": "text-input",
          "values": "",
          "selected": ""
        }, {
          "name": "Enable Included Style Types",
          "type": "list",
          "values": ["yes", "no"],
          "selected": "no"
        }, {
          "name": "Use Regex for Included Style Types",
          "type": "list",
          "values": ["yes", "no"],
          "selected": "no"
        }]
      }
    },
    "Adobe Encore": {
      options: {
        decode: [],
        encode: []
      },
      name: "adobeEncore"
    },
    "Apple DVD Studio Pro": {
      options: {
        decode: [],
        encode: []
      },
      name: "appleDvdStudioPro"
    },
    "Avid DS": {
      options: {
        decode: [],
        encode: []
      },
      name: "avidDs"
    },
    "Cheetah (ASCII Text)": {
      options: {
        decode: [],
        encode: []
      },
      name: "cheetahAscii"
    },
    "Cheetah (binary)": {
      options: {
        decode: [],
        encode: []
      },
      name: "cheetahBin"
    },
    "CaptionMaker Plus": {
      name: "captionMakerPlus",
      options: {
        decode: [],
        encode: []
      }
    },
    "CaptionMaker Plus V2": {
      name: "captionMakerPlusV2",
      options: {
        decode: [],
        encode: []
      }
    },
    "Videotron Lambda": {
      options: {
        decode: [],
        encode: [{
          name: "Scene Name",
          type: "text-input",
          values: "",
          selected: "Untitled"
        }]
      },
      name: "videotronLambda"
    },
    "NCI Caption": {
      options: {
        decode: [],
        encode: []
      },
      name: "nciCaption"
    },
    "NCI Timed Roll Up Captions": {
      options: {
        decode: [],
        encode: []
      },
      name: "nciTimedRollUpCaptions"
    },
    "Distribution Format Exchange Profile (DFXP)": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "10"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "SansSerif"
        }, {
          name: "Font Style",
          type: "list",
          values: ["normal", "italic", "oblique"],
          selected: "normal"
        }, {
          name: "Font Weight",
          type: "list",
          values: ["normal", "bold"],
          selected: "normal"
        }, {
          name: "Encode Formatting",
          type: "list",
          values: [true, false],
          selected: true
        }, {
          name: "Encode Color",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Text Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "transparent"
        }, {
          name: "Format XML",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "dfxp"
    },
    "Crunchyroll DFXP": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "crunchyrollDfxp"
    },
    "Netflix DFXP": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "netflixDfxp"
    },
    "DCDM Subtitle": {
      options: {
        decode: [],
        encode: []
      },
      name: "dcdmSubtitle"
    },
    "DLP Cinema": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Reel Number",
          type: "number-input",
          values: "",
          selected: "1"
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Fade Up Time",
          type: "number-input",
          values: "",
          selected: "20"
        }, {
          name: "Fade Down Time",
          type: "number-input",
          values: "",
          selected: "20"
        }, {
          name: "Vertical Position Start",
          type: "number-input",
          values: "",
          selected: "10"
        }, {
          name: "Vertical Spacing",
          type: "number-input",
          values: "",
          selected: "6"
        }]
      },
      name: "dlpCinema"
    },
    "DVD Architect": {
      options: {
        decode: [],
        encode: []
      },
      name: "dvdArch"
    },
    "EBU STL": {
      options: {
        decode: [{
          name: "Decode Speakers By Color",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Speaker Identifier",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Insert Speaker Identifier",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Speaker Is Greater Than",
          type: "number-input",
          values: "",
          selected: 1
        }],
        encode: [{
          name: "Display Standard Code",
          type: "list",
          values: ["Undefined", "Open subtitling", "Level-1 teletext", "Level-2 teletext"],
          selected: "Open subtitling"
        }, {
          name: "Double Height Characters",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Program Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Episode Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Translated Program Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Translated Episode Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Translator's Name",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Translator's Contact Details",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Subtitle List Ref Code",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Publisher",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Editor's Name",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Editor's Contact Details",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Language Code",
          type: "list",
          values: ["Albanian", "Amharic", "Arabic", "Armenian", "Assamese", "Azerbaijani", "Bambora", "Basque", "Bengali", "Bielorussian", "Breton", "Bulgarian", "Burmese", "Catalan", "Chinese", "Churash", "Croatian", "Czech", "Danish", "Dari", "Dutch", "English", "Esperanto", "Estonian", "Faroese", "Finnish", "Flemish", "French", "Frisian", "Fulani", "Gaelic", "Galician", "Georgian", "German", "Greek", "Gujurati", "Gurani", "Hausa", "Hebrew", "Hindi", "Hungarian", "Icelandic", "Indonesian", "Irish", "Italian", "Japanese", "Kannada", "Kazakh", "Khmer", "Korean", "Laotian", "Lappish", "Latin", "Latvian", "Lithuanian", "Luxembourgian", "Macedonian", "Malagasay", "Malaysian", "Maltese", "Marathi", "Moldavian", "Ndebele", "Nepali", "Norwegian", "Occitan", "Oriya", "Papamiento", "Persian", "Polish", "Portugese", "Punjabi", "Pushtu", "Quechua", "Romanian", "Romansh", "Russian", "Ruthenian", "Serbian", "Serbo-croat", "Shona", "Sinhalese", "Slovak", "Slovenian", "Somali", "Spanish", "Sranan Tongo", "Swahili", "Swedish", "Tadzhik", "Tamil", "Tatar", "Telugu", "Thai", "Turkish", "Ukrainian", "Unknown/not applicable", "Urdu", "Uzbek", "Vietnamese", "Wallon", "Welsh", "Zulu"],
          selected: "English"
        }, {
          name: "GSI Character Set",
          type: "list",
          values: ["United States", "Multilingual", "Portuguese", "Canada-French", "Nordic"],
          selected: "Multilingual"
        }, {
          name: "Character Code Table",
          type: "list",
          values: ["Latin", "Cyrillic", "Arabic", "Greek", "Hebrew"],
          selected: "Latin"
        }, {
          name: "Country of Origin",
          type: "list",
          values: ["Bahrain", "Aruba", "Bahamas", "Afghanistan", "Belize", "Angola", "Bermuda", "Anguilla", "Bolivia", "Albania", "Brazil", "Andorra", "Barbados", "Netherlands Antilles", "Brunei Darussalam", "United Arab Emirates", "Bhutan", "Argentina", "Burma", "American Samoa", "Bouvet Island", "Antarctica", "Botswana", "French Southern Territories", "Byelorussian SSR", "Antigua and Barbuda", "Central African Republic", "Canada", "Australia", "Cocos (Keeling) Islands", "Austria", "Switzerland", "Burundi", "Chile", "Belgium", "China", "Benin", "Côte d'Ivoire", "Burkina Faso", "Cameroon", "Bangladesh", "Congo", "Bulgaria", "Cook Islands", "Colombia", "French Guinea", "Comoros", "Guam", "Cape Verde", "Guyana", "Costa Rica", "Hong Kong", "Czechoslovakia", "Heard and Mc Donald Islands", "Honduras", "Cuba", "Haiti", "Christmas Island", "Hungary", "Cayman Islands", "Cyprus", "Indonesia", "German Democratic Republic", "India", "Germany, Federal Republic of", "British Indian Ocean Territory", "Djibouti", "Ireland", "Dominica", "Iran", "Denmark", "Iraq", "Dominican Republic", "Iceland", "Algeria", "Israel", "Ecuador", "Italy", "Egypt", "Jamaica", "Western Sahara", "Jordan", "Spain", "Japan", "Ethiopia", "Finland", "Kenya", "Fiji", "Kampuchea, Democratic", "Falkland Islands (Malvinas)", "Kiribati", "France", "Saint Kitts and Nevis", "Faroe Islands", "Korea, Republic of", "Micronesia", "Kuwait", "Gabon", "Lao, People's Democratic Republic of", "United Kingdom", "Lebanon", "Ghana", "Liberia", "Gibraltar", "Libyan Arab Jamahiriya", "Guinea", "Saint Lucia", "Guadeloupe", "Liechtenstein", "Gambia", "Sri Lanka", "Guinea-Bissau", "Lesotho", "Equatorial Guinea", "Luxembourg", "Greece", "Macau", "Grenada", "Morocco", "Greenland", "Monaco", "Guatemala", "Madagascar", "Maldives", "Korea, Democratic People's Republic of", "Mexico", "Portugal", "Marshall Islands", "Paraguay", "Mali", "French Polynesia", "Malta", "Qatar", "Mongolia", "Nothern Mariana Islands", "Réunion", "Mozambique", "Romania", "Mauritania", "Rwanda", "Montserrat", "Saudi Arabia", "Martinique", "Sudan", "Mauritius", "Senegal", "Malawi", "Singapore", "Malaysia", "St. Helena", "Namibia", "Svalbard and Jan Mayen Islands", "New Caledonia", "Solomon Islands", "Niger", "Sierra Leone", "Norfolk Island", "El Salvador", "Nigeria", "San Marino", "Nicaragua", "Somalia", "Niue", "St. Pierre and Miquelon", "Netherlands", "Sao Tome and Principé", "Norway", "USSR", "Nepal", "Surinam", "Nauru", "Sweden", "Neutral Zone", "Swaziland", "New Zealand", "Seychelles", "Oman", "Syrian Arab Republic", "Turks and Caicos Islands", "Pakistan", "Chad", "Panama", "Togo", "Thailand", "Pitcairn", "Tokelau", "Peru", "East Timor", "Philippines", "Tonga", "Palau", "Trinidad and Tobago", "Papua New Guinea", "Tunisia", "Poland", "Turkey", "Puerto Rico", "Tuvalu", "Taiwan, Province of China", "Vanuatu", "Tanzania, United Republic of", "Uganda", "Wallis and Futuna Islands", "Ukrainian SSR", "Samoa", "United States Minor Outlying Islands", "Uruguay", "Yemen", "United States", "Yemen, Democratic", "Vatican City State (Holy See)", "Yugoslavia", "Saint Vincent and the Grenadines", "South Africa", "Venezuela", "Zaire", "Virgin Islands (British)", "Zambia", "Viet Nam"],
          selected: "Canada"
        }, {
          name: "SOM",
          type: "text-input",
          values: "00:00:00:00",
          selected: "00:00:00:00"
        }, {
          name: "Max Number of Rows",
          type: "number-input",
          values: "",
          selected: "23"
        }, {
          name: "Max Number of Characters Per Row",
          type: "number-input",
          values: "",
          selected: "40"
        }, {
          name: "Include Blank Subtitle At Start",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Include Blank Subtitle At End",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }]
      },
      name: "ebuStl"
    },
    "EBU TT": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "ebuTt"
    },
    "EBU-TT-D": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Cell Resolution",
          type: "text-input",
          values: "",
          selected: "32 15"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospaceSansSerif"
        }, {
          name: "Font Size",
          type: "number-input",
          values: "",
          selected: "160"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Style",
          type: "text-input",
          values: "",
          selected: "normal"
        }]
      },
      name: "ebuTtD"
    },
    "Text Transcript": {
      options: {
        decode: [{
          name: "Max Characters Per Line",
          type: "number-input",
          values: "",
          selected: "32"
        }, {
          name: "Max Lines Per Event",
          type: "number-input",
          values: "",
          selected: "2"
        }, {
          name: "Reading Rate",
          type: "number-input",
          values: "",
          selected: "20"
        }, {
          name: "Split on Comma",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Split on Punctuation",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Block Import",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }],
        encode: [{
          name: "Include Speaker Name",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Include Timestamp",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Split On Event Gap",
          type: "number-input",
          values: "",
          selected: 4
        }, {
          name: "Max Words",
          type: "number-input",
          values: "",
          selected: 99999
        }, {
          name: "Event Prefix",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Event Suffix",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Encode Formatting",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "textTranscript"
    },
    "Eclipse": {
      options: {
        decode: [],
        encode: []
      },
      name: "eclipse"
    },
    "EZ Title": {
      options: {
        decode: [],
        encode: []
      },
      name: "ezTitle"
    },
    "MacCaption 608/708": {
      options: {
        decode: [{
          name: "Channel",
          type: "list",
          values: ["ch01", "ch02", "ch03", "ch04", "programA", "programB", "programC", "programD", "programE", "programF"],
          selected: "ch01"
        }],
        encode: [{
          name: "MCC Version",
          type: "list",
          values: ["2.0", "1.0"],
          selected: "2.0"
        }, {
          name: "Compress Output",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }]
      },
      name: "macCaption"
    },
    "608/708 VANC Data": {
      options: {
        decode: [],
        encode: []
      },
      name: "vancData"
    },
    "DVB Teletext TS Stream": {
      options: {
        decode: [{
          name: "Teletext Page",
          type: "text-input",
          values: "",
          selected: "888"
        }, {
          name: "Field Rate",
          type: "list",
          values: ["50", "60", "25", "30"],
          selected: "50"
        }, {
          name: "Post Process",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Dump Timeline",
          type: "list",
          values: ["no", "yes"],
          selected: "no"
        }],
        encode: []
      },
      name: "tsStream"
    },
    "MacCaption 608/708 Advanced": {
      options: {
        encode: [{
          name: "MCC Version",
          type: "list",
          values: ["2.0", "1.0"],
          selected: "2.0"
        }, {
          name: "Compress Output",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }]
      },
      name: "macCaptionAdvanced"
    },
    "MAGIC TT": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Title",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Description",
          type: "text-input",
          values: "",
          selected: "en"
        }]
      },
      name: "magicTt"
    },
    "Netflix TT Captions": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "netflixTtCaptions"
    },
    "Netflix TT Subtitles": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "netflixTtSubtitles"
    },
    "PowerPixel Format": {
      options: {
        decode: [],
        encode: []
      },
      name: "powerPixel"
    },
    "ProCap Transfer": {
      options: {
        decode: [],
        encode: [{
          name: "Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Author",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Owner",
          type: "text-input",
          values: "",
          selected: ""
        }]
      },
      name: "proCapTransfer"
    },
    "Synchronized Accessible Media Interchange": {
      options: {
        decode: [],
        encode: []
      },
      name: "sami"
    },
    "Scenarist V1.0": {
      name: "scenerist",
      options: {
        decode: [{
          name: "Channel",
          type: "list",
          values: ["auto", "ch01", "ch02", "ch03", "ch04"],
          selected: "auto"
        }],
        encode: [{
          name: "Channel",
          type: "list",
          values: ["ch01", "ch02", "ch03", "ch04"],
          selected: "ch01"
        }, {
          name: "Line Endings",
          type: "list",
          values: ["windows", "unix", "macintosh"],
          selected: "unix"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["colon", "semi-colon", "auto"],
          selected: "auto"
        }, {
          name: "Include Blank Subtitle At Start",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Include Blank Subtitle At End",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }]
      }
    },
    "Scenarist V1.0 Advanced": {
      name: "sceneristAdvanced",
      options: {
        decode: [],
        encode: [{
          name: "Line Endings",
          type: "list",
          values: ["windows", "unix", "macintosh"],
          selected: "unix"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["colon", "semi-colon", "auto"],
          selected: "auto"
        }, {
          name: "Include Blank Subtitle At Start",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }, {
          name: "Include Blank Subtitle At End",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }]
      }
    },
    "Spruce STL": {
      options: {
        decode: [],
        encode: []
      },
      name: "spruceStl"
    },
    "Cavena CIP": {
      name: "cavenaCip",
      options: {
        decode: [],
        encode: []
      }
    },
    "Cavena 890": {
      name: "cavena890",
      options: {
        decode: [{
          name: "Decode Line 1",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }, {
          name: "Decode Line 2",
          type: "list",
          values: ["yes", "no"],
          selected: "yes"
        }],
        encode: [{
          name: "Line 1 Language",
          type: "list",
          values: ["Danish", "Norwegian", "English", "Russian", "Greek", "Romanian", "Swedish", "Arabic", "Hebrew", "Traditional Chinese", "Simplified Chinese"],
          selected: "English"
        }, {
          name: "Line 2 Language",
          type: "list",
          values: ["Danish", "Norwegian", "English", "Russian", "Greek", "Romanian", "Swedish", "Arabic", "Hebrew", "Traditional Chinese", "Simplified Chinese"],
          selected: "English"
        }, {
          name: "Font Family Line 1",
          type: "list",
          values: ["auto", "HLV23N", "CCKM44", "ARA19N", "KYRIL4", "HEBNOA", "GREEK4", "VFONTL"],
          selected: "auto"
        }, {
          name: "Font Family Line 2",
          type: "list",
          values: ["auto", "HLV23N", "CCKM44", "ARA19N", "KYRIL4", "HEBNOA", "GREEK4", "VFONTL"],
          selected: "auto"
        }, {
          name: "SOM",
          type: "text-input",
          values: "",
          selected: "00:00:00:00"
        }, {
          name: "Tape Number",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Programme Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Translated Programme Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Translator",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Translated Episode Title",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "Comments",
          type: "text-input",
          values: "",
          selected: ""
        }, {
          name: "RTL Text Processing",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }]
      }
    },
    "ScreenSystems Poliscript": {
      options: {
        decode: [{
          name: "Code Page",
          type: "list",
          values: ["auto", "ISO 8859-1 Latin", "ISO 8859-7 Greek", "ISO 8859-2 Latin 2", "ISO 8859-6 Arabic", "ISO 8859-8 Hebrew", "ISO 8859-9 Turkish", "Windows-874 Thai", "ISO 8859-5 Cyrillic", "Big5 Traditional Chinese", "GBK Simplified Chinese", "Korean", "Japanese Shift-JIS"],
          selected: "auto"
        }, {
          name: "Ignore Metadata",
          type: "list",
          values: [true, false],
          selected: true
        }],
        encode: [{
          name: "Encode Story Event",
          type: "list",
          values: [true, false],
          selected: true
        }, {
          name: "Story Event Text",
          type: "textarea",
          values: "",
          selected: "TITLE: Unknown\nSTORY: Unknown\nLANG: Unknown"
        }, {
          name: "Code Page",
          type: "list",
          values: ["auto", "ISO 8859-1 Latin", "ISO 8859-7 Greek", "ISO 8859-2 Latin 2", "ISO 8859-6 Arabic", "ISO 8859-8 Hebrew", "ISO 8859-9 Turkish", "Windows-874 Thai", "ISO 8859-5 Cyrillic", "Big5 Traditional Chinese", "GBK Simplified Chinese", "Korean", "Japanese Shift-JIS"],
          selected: "auto"
        }]
      },
      name: "ssPoliscript"
    },
    "PAC Unicode (UniPac)": {
      options: {
        decode: [{
          name: "Ignore Metadata",
          type: "list",
          values: [true, false],
          selected: true
        }],
        encode: [{
          name: "Encode Story Event",
          type: "list",
          values: [true, false],
          selected: true
        }, {
          name: "Story Event Text",
          type: "textarea",
          values: "",
          selected: "TITLE: Unknown\nSTORY: Unknown\nLANG: Unknown"
        }]
      },
      name: "ssPoliscriptUnicode"
    },
    "JSON Format Custom 01": {
      options: {
        decode: [],
        encode: []
      },
      name: "json_custom_01"
    },
    "Rich Text Format Custom 01": {
      options: {
        decode: [],
        encode: []
      },
      name: "rtf_custom_01"
    },
    "SubRip Video Subtitle Script": {
      timecode: "ms",
      options: {
        decode: [],
        encode: [{
          name: "Encode Formatting",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Positioning",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Ruby",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "subRip"
    },
    "SubViewer": {
      options: {
        decode: [],
        encode: []
      },
      name: "subViewer"
    },
    "Canvass SST Project": {
      options: {
        decode: [{
          name: "Track",
          type: "list",
          values: ["A", "B", "All"],
          selected: "A"
        }],
        encode: []
      },
      name: "canvassSst"
    },
    "Sofni": {
      options: {
        decode: [],
        encode: []
      },
      name: "sofni"
    },
    "Timed-Text Markup Language": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Font Color",
          type: "text-input",
          values: "",
          selected: "white"
        }, {
          name: "Background Color",
          type: "text-input",
          values: "",
          selected: "black"
        }, {
          name: "Font Family",
          type: "text-input",
          values: "",
          selected: "monospace"
        }, {
          name: "Font Size (%)",
          type: "number-input",
          values: "",
          selected: "80"
        }, {
          name: "Font Weight",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Font Style",
          type: "text-input",
          values: "",
          selected: "normal"
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }]
      },
      name: "ttml"
    },
    "Verizon TTML": {
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Language Code",
          type: "text-input",
          values: "",
          selected: "en"
        }, {
          name: "Line Height",
          type: "number-input",
          values: "",
          selected: 5.33
        }, {
          name: "Timecode Format",
          type: "list",
          values: ["smpte", "ms"],
          selected: "smpte"
        }, {
          name: "608 Format",
          type: "list",
          values: ["yes", "no"],
          selected: "no"
        }]
      },
      name: "ttmlVerizon"
    },
    "Able Player DV": {
      timecode: "ms",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }]
      },
      name: "ablePlayerDv"
    },
    "WebVTT": {
      timecode: "ms",
      name: "webVtt",
      options: {
        decode: [],
        encode: [{
          name: "Encode Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Id",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Position",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Position Template",
          type: "list",
          values: ["Default", "Standard", "YouTube", "MUFI", "VLC", "Ooona", "Custom01", "Custom02", "Custom03", "Custom04"],
          selected: "Default"
        }, {
          name: "Encode Speaker Cues",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Color",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Formatting",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Ruby",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Font Styles",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Encode Metadata Notes",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Metadata Notes",
          type: "textarea",
          values: "",
          selected: ""
        }, {
          name: "Use HTML Tags",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Override Font Color",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Override Background Color",
          type: "list",
          values: [true, false],
          selected: false
        }, {
          name: "Font Color",
          type: "list",
          values: ["white", "lime", "cyan", "red", "yellow", "magenta", "blue", "black"],
          selected: "white"
        }, {
          name: "Background Color",
          type: "list",
          values: ["white", "lime", "cyan", "red", "yellow", "magenta", "blue", "black"],
          selected: "black"
        }, {
          name: "Max Characters Per Line",
          type: "number-input",
          values: "",
          selected: 40
        }]
      }
    },
    "Comma-Separated Values": {
      options: {
        decode: [{
          name: "Start Time",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "A"
        }, {
          name: "End Time",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "B"
        }, {
          name: "Start Time Format",
          type: "list",
          values: ["SMPTE Timecode (HH:MM:SS:FF)", "MS Timecode (HH:MM:SS.MSS)", "Seconds (SS)", "Timecode (HH:MM:SS)"],
          selected: "SMPTE Timecode (HH:MM:SS:FF)"
        }, {
          name: "End Time Format",
          type: "list",
          values: ["SMPTE Timecode (HH:MM:SS:FF)", "MS Timecode (HH:MM:SS.MSS)", "Seconds (SS)", "Timecode (HH:MM:SS)"],
          selected: "SMPTE Timecode (HH:MM:SS:FF)"
        }, {
          name: "Text",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "C"
        }, {
          name: "Original Text",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "NONE"
        }, {
          name: "Notes",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "NONE"
        }, {
          name: "Reply",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "NONE"
        }, {
          name: "Speakers",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "NONE"
        }, {
          name: "Recipients",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "NONE"
        }, {
          name: "Approved",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "NONE"
        }, {
          name: "Approval Passed Value",
          type: "text-input",
          values: "",
          selected: "passed"
        }, {
          name: "Tags",
          type: "list",
          values: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "NONE"],
          selected: "NONE"
        }],
        encode: []
      },
      name: "csv"
    },
    "JSON": {
      options: {
        decode: [],
        encode: []
      },
      name: "json"
    }
  },
  clockTimeFormats: ["SubRip Video Subtitle Script", "WebVTT", "Able Player DV", "SubViewer", "LMS Transcript", "As-Broadcast Dialogue List Word", "Dialogue List Custom 01", "Timed-Text Markup Language", "Distribution Format Exchange Profile (DFXP)", "DLP Cinema", "Netflix TT Captions", "Netflix TT Subtitles", "MAGIC TT", "EBU TT", "SMPTE TTML", "IMSC Text Captions", "IMSC Text Subtitles", "IMSC 1.1 Text Profile", "DCDM Subtitle", "Ooona TTML", "IMSC 1.0 Basic", "TTML FooEngine", "Broadstream TTML", "Paramount IMSC 1.1"],
  binaryFormats: ["cheetahBin", "ebuStl", "ssPoliscript", "ssPoliscriptUnicode", "cavena890", "nciCaption", "captionInc", "captionMakerPlus", "captionMakerPlusV2", "vancData"],
  bufferFormats: ["tsStream", "esef"],
  defaultEncodingMap: {
    "ttmlFooEngine": "utf-8",
    "disneyTtml": "utf-8",
    "paramountImsc11": "utf-8",
    "sandflowTtml": "utf-8",
    "captionInc": "hex",
    "esef": "buffer",
    "dialogueListCustom01": "buffer",
    "ms2Transcript": "buffer",
    "lmsTranscript": "buffer",
    "dvwQcScript": "buffer",
    "dvwStudioScript": "buffer",
    "exad": "buffer",
    "dialogueListWord": "buffer",
    "davinciResolveTimelineMarkers": "utf-8",
    "davinciResolveAdrCueList": "utf-8",
    "davinciResolveEditIndexList": "utf-8",
    "dialogueListCsv": "utf-8",
    "closedCaptionProject": "utf-8",
    "iTunesTimedText": "utf-8",
    "googleStt": "utf-8",
    "voicegain": "utf-8",
    "elevenLabsScribe": "utf-8",
    "whisper": "utf-8",
    "speechmatics": "utf-8",
    "amazonTranscribe": "utf-8",
    "deepgram": "utf-8",
    "revAi": "utf-8",
    "assemblyAi": "utf-8",
    "gladia": "utf-8",
    "vitac": "utf-8",
    "subStationAlpha": "utf-8",
    "uDvd": "utf-8",
    "quickTimeText": "utf-8",
    "fcpXml": "utf-8",
    "adobeEncore": "utf-8",
    "appleDvdStudioPro": "utf-8",
    "avidDs": "utf-16le",
    "captionMakerPlus": "hex",
    "captionMakerPlusV2": "hex",
    "videotronLambda": "shift-jis",
    "nciCaption": "hex",
    "nciTimedRollUpCaptions": "utf-8",
    "cheetahBin": "hex",
    "cavena890": "hex",
    "cheetahAscii": "utf-8",
    "eclipse": "utf-8",
    "textTranscript": "utf-8",
    "dfxp": "utf-8",
    "dlpCinema": "utf-8",
    "dcdmSubtitle": "utf-8",
    "dvdArch": "utf-16le",
    "ebuStl": "hex",
    "ebuTt": "utf-8",
    "ebuTtD": "utf-8",
    "ezTitle": "utf-8",
    "vancData": "hex",
    "tsStream": "hex",
    "macCaption": "utf-8",
    "macCaptionAdvanced": "utf-8",
    "magicTt": "utf-8",
    "netflixTtCaptions": "utf-8",
    "netflixTtSubtitles": "utf-8",
    "crunchyrollDfxp": "utf-8",
    "netflixDfxp": "utf-8",
    "powerPixel": "utf-8",
    "proCapTransfer": "latin1",
    "sami": "utf-8",
    "scenerist": "utf-8",
    "sceneristAdvanced": "utf-8",
    "sofni": "utf-8",
    "spruceStl": "utf-8",
    "ssPoliscript": "hex",
    "ssPoliscriptUnicode": "hex",
    "json_custom_01": "utf-8",
    "rtf_custom_01": "utf-8",
    "subRip": "utf-8",
    "subViewer": "utf-8",
    "canvassSst": "hex",
    "cavenaCip": "utf-8",
    "ttml": "utf-8",
    "ttmlVerizon": "utf-8",
    "imscTextCaptionsJa": "utf-8",
    "imscTextCaptions": "utf-8",
    "imscTextSubtitles": "utf-8",
    "imsc11": "utf-8",
    "imscRosetta": "utf-8",
    "hboGoTtml": "utf-8",
    "hboMaxSmpte": "utf-8",
    "ttmlLegacy": "utf-8",
    "ooonaTtml": "utf-8",
    "imscBasic": "utf-8",
    "hboSmpteTtml": "utf-8",
    "smpteTtml": "utf-8",
    "adobeTtml": "utf-8",
    "aeTtml": "utf-8",
    "broadstreamTtml": "utf-8",
    "youtubeTtml": "utf-8",
    "webVtt": "utf-8",
    "ablePlayerDv": "utf-8",
    "json": "utf-8",
    "csv": "utf-8"
  },
  defaultExtMap: {
    "crunchyrollDfxp": "dfxp",
    "dvwStudioScript": "xslx",
    "dvwQcScript": "xslx",
    "exad": "xslx",
    "disneyTtml": "ttml",
    "paramountImsc11": "xml",
    "sandflowTtml": "ttml",
    "ttmlFooEngine": "ttml",
    "captionInc": "cin",
    "dialogueListCustom01": "docx",
    "ms2Transcript": "docx",
    "lmsTranscript": "docx",
    "dialogueListWord": "docx",
    "davinciResolveTimelineMarkers": "edl",
    "davinciResolveAdrCueList": "csv",
    "davinciResolveEditIndexList": "csv",
    "dialogueListCsv": "csv",
    "esef": "esf",
    "cavena890": "890",
    "closedCaptionProject": "ccprj",
    "iTunesTimedText": "itt",
    "voicegain": "json",
    "elevenLabsScribe": "json",
    "whisper": "json",
    "speechmatics": "json",
    "googleStt": "json",
    "amazonTranscribe": "json",
    "deepgram": "json",
    "revAi": "json",
    "assemblyAi": "json",
    "gladia": "json",
    "vitac": "vnl",
    "subStationAlpha": "aas",
    "uDvd": "sub",
    "quickTimeText": "txt",
    "fcpXml": "xml",
    "adobeEncore": "txt",
    "appleDvdStudioPro": "txt",
    "eclipse": "txt",
    "textTranscript": "txt",
    "avidDs": "txt",
    "cheetahBin": "cap",
    "videotronLambda": "cap",
    "captionMakerPlus": "cap",
    "captionMakerPlusV2": "cap",
    "nciCaption": "cap",
    "nciTimedRollUpCaptions": "flc",
    "cheetahAscii": "asc",
    "dfxp": "dfxp",
    "netflixDfxp": "dfxp",
    "dlpCinema": "xml",
    "dcdmSubtitle": "xml",
    "dvdArch": "sub",
    "ebuStl": "stl",
    "ebuTt": "xml",
    "ebuTtD": "xml",
    "ezTitle": "txt",
    "vancData": "raw",
    "tsStream": "ts",
    "macCaption": "mcc",
    "macCaptionAdvanced": "mcc",
    "magicTt": "xml",
    "netflixTtCaptions": "xml",
    "netflixTtSubtitles": "xml",
    "powerPixel": "txt",
    "proCapTransfer": "txt",
    "sami": "smi",
    "scenerist": "scc",
    "sceneristAdvanced": "scc",
    "sofni": "sub",
    "spruceStl": "stl",
    "ssPoliscript": "pac",
    "ssPoliscriptUnicode": "fpc",
    "json_custom_01": "json",
    "rtf_custom_01": "rtf",
    "subRip": "srt",
    "subViewer": "sub",
    "canvassSst": "sdb",
    "cavenaCip": "cip",
    "ttml": "ttml",
    "ttmlVerizon": "ttml",
    "hboGoTtml": "ttml",
    "hboMaxSmpte": "xml",
    "ttmlLegacy": "ttml",
    "hboSmpteTtml": "ttml",
    "smpteTtml": "ttml",
    "adobeTtml": "xml",
    "aeTtml": "xml",
    "youtubeTtml": "ttml",
    "ooonaTtml": "xml",
    "imscBasic": "ttml",
    "imsc11": "ttml",
    "imscRosetta": "imscr",
    "imscTextCaptionsJa": "ttml",
    "imscTextCaptions": "ttml",
    "imscTextSubtitles": "ttml",
    "webVtt": "vtt",
    "ablePlayerDv": "vtt",
    "json": "json",
    "csv": "csv",
    "cca": "cca"
  },
  getSrcProfileDisplayNames: function () {
    let profiles = [];
    for (let [key, values] of Object.entries(this.srcProfiles)) {
      values.forEach(value => {
        profiles.push(value);
      });
    }
    return [...new Set(profiles)];
  },
  getTrgProfileDisplayNames: function () {
    let profiles = [];
    for (let [key, values] of Object.entries(this.trgProfiles)) {
      values.forEach(value => {
        profiles.push(value);
      });
    }
    return [...new Set(profiles)];
  },
  getSrcProfiles: function () {
    let profiles = [];
    let profileMapping = this.profileMapping;
    for (let [key, values] of Object.entries(this.srcProfiles)) {
      values.forEach(value => {
        profiles.push(profileMapping[value].name);
      });
    }
    return [...new Set(profiles)];
  },
  getTrgProfiles: function () {
    let profiles = [];
    let profileMapping = this.profileMapping;
    for (let [key, values] of Object.entries(this.trgProfiles)) {
      values.forEach(value => {
        profiles.push(profileMapping[value].name);
      });
    }
    return [...new Set(profiles)].sort();
  },
  getSrcProfileByExtension: function (ext) {
    return this.srcProfiles[ext][0];
  },
  getTrgProfileByExtension: function (ext) {
    return this.trgProfiles[ext][0];
  },
  getSrcProfileByExtension: function (ext) {
    let profileDisplayName = this.getSrcProfileByExtension(ext);
    let srcProfile = this.profileMapping[profileDisplayName].name;
    return srcProfile;
  },
  getTrgProfileByExtension: function (ext) {
    let profileDisplayName = this.getTrgProfileByExtension(ext);
    let trgProfile = this.profileMapping[profileDisplayName].name;
    return trgProfile;
  },
  getProfileTitleByName: function (name) {
    for (let [key, value] of Object.entries(this.profileMapping)) {
      if (this.profileMapping[key].name === name) {
        return key;
      }
    }
    return new Error(name + " is not a supported format. Please check casing or contact support");
  }
};